module.exports = __webpack_public_path__ + "static/img/14_.d87cb15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/14_.jpg
// module id = B/Yu
// module chunks = 1